// extracted by mini-css-extract-plugin
export default {"Footer":"FoursourceFooter_Footer__hPuNv","Logo":"FoursourceFooter_Logo__9EXER"};